<template>
  <div class="applicateDetails">
    <div class="jobBox">
      <div class="jobPart">
        <div class="person">{{ contentData.position }}</div>
        <div class="place">
          {{ contentData.area }}｜{{ contentData.location }}
        </div>
      </div>
      <div class="content">
        <p style="margin: 19px 0 0">工作职责:</p>
        <div v-html="contentData.duties"></div>
        <p style="margin: 19px 0 0">任职资格:</p>
        <div v-html="contentData.claim"></div>
        <p>
          联系方式：<br />
          {{ contentData.contact }}
        </p>
      </div>
      <div class="return">
        <button @click="$router.go(-1)">返回列表</button>
      </div>
    </div>
  </div>
</template>
<script>
import { apiGetOfferDetails } from "../../api/index";

export default {
  metaInfo: {
      title: '应聘详情-爱情地产',
      meta: [{
      name: 'keyWords',
      content: '爱情地产'
      },
      {
      name: 'description',
      content: ''
      }]
  },
  data() {
    return {
      contentData: {},
    };
  },
  created() {
    apiGetOfferDetails(this.$route.params.id).then((data) => {
      if (data.data.status == 1) this.contentData = data.data.offer;
    });
  },
};
</script>
<style scoped lang='less'>
.jobBox {
  padding: 0 15px;
  .jobPart {
    padding: 20px 0;
    border-bottom: 1px solid #efefef;
    .person {
      color: #333;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 10px;
      font-weight: 500;
    }
    .place {
      font-size: 12px;
      line-height: 17px;
      color: #666666;
    }
  }
  .content {
    padding-top: 19px;
    font-size: 12px;
    line-height: 20px;
    color: #666666;
    p {
      margin-bottom: 15px;
      div{
        p{
          margin: 0;
        }
      }
    }
  }
  .return {
    padding-bottom: 30px;
    button {
      color: #333;
      font-size: 14px;
      line-height: 20px;
      padding: 10px 47px;
      background: #efefef;
      border-radius: 5px;
      border: none;
      outline: none;
    }
  }
}
</style>